import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import React from 'react';
import '../Home.css';

const sx = {
  table: {
    maxWidth: '700px',
    margin: 'auto',
    borderCollapse: 'separate',
  },
  header: {
    border: '2px solid #D2D4C2 ',
  },
  th: {
    color: '#D2D4C2',
  },
  td: {
    border: '2px solid #D2D4C2',
    borderBottom: '1px solid',
    borderTop: '1px solid',

    color: '#D2D4C2',
  },
};

const ROWS = [
  {
    title: 'All 15 characters',
    prize: '0.25 ETH',
  },
  {
    title: 'Rare Collection (all 15 characters are rare)',
    prize: '0.5 ETH',
  },
  {
    title: 'Epic Collection (all 15 cards are perfect)',
    prize: '1.5 ETH',
  },
  {
    title:
      'Legendary Collection (all 15 characters are rare and the cards are perfect)',
    prize: '3.5 ETH',
  },
];

const GameTable = () => {
  return (
    <Table sx={sx.table}>
      <TableHead sx={sx.header}>
        <TableRow sx={sx.th}>
          <TableCell
            sx={sx.td}
            align="left"
            style={{ fontFamily: 'poppins-semibold' }}
          >
            Collection type
          </TableCell>
          <TableCell
            sx={sx.td}
            align="left"
            style={{ fontFamily: 'poppins-semibold' }}
          >
            Prize
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {ROWS.map((row, index) => (
          <TableRow key={index} sx={sx.td}>
            <TableCell sx={sx.td} align="left">
              {row.title}
            </TableCell>
            <TableCell sx={sx.td} align="left">
              {row.prize}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default GameTable;
